<template>
  <div>
    <el-form class="lesson-entity-form" ref="form" label-width="100px">
      <el-form-item label="位置">
        <el-input v-model="weight"></el-input>
      </el-form-item>
      <component :is="setting" ref="setting" :form="form"></component>
    </el-form>
  </div>
</template>

<script>
import kewen from './../settings/kewen'
import exercise from './../settings/exercise'
import iq_word from './../settings/iq_word'
import iq_words from './../settings/iq_words'
import iq_writing from './../settings/iq_writing'
import iq_sentence from './../settings/iq_sentence'

export default {
  name: 'LessonEntityForm',
  data () {
    return {
      cid: null,
      unid: null,
      ids: null,
      weight: 0,
      form: {}
    }
  },
  components: { kewen, exercise, iq_word, iq_words, iq_writing, iq_sentence },
  computed: {
    isBatchUpdate () {
      return this.ids instanceof Array
    },
    setting () {
      if (this.isBatchUpdate || !this.form) {
        return null
      }
      let type = this.form.entity_type
      if (type === 'kwparg' || type === 'industry_kewen') {
        type = 'kewen'
      } else if(type === 'industry_word') {
        type = 'word';
      }
      if (type in this.$options.components) {
        return type
      }
      return null
    }
  },
  methods: {
    getFormData () {
      return {}
    },
    reset (item) {
      let params = Object.assign({
        cid: null,
        unid: null,
        ids: null,
        form: null
      }, item)
      this.cid = params.cid
      this.unid = params.unid
      this.form = { ...params.form }
      this.weight = this.form.weight ? (this.form.weight + 1) : 1
      if (params.ids instanceof Array) {
        this.ids = params.ids.map(n => {
          return typeof n === 'number' ? n : n.id
        })
      } else if (params.ids) {
        this.ids = null
        this.form.id = params.ids
      }
    },
    submit () {
      let formData = this.getFormData()
      if (this.$refs.setting) {
        Object.assign(formData, this.$refs.setting.getFormData())
      }
      if (this.form.id) {
        if (this.form.weight != this.weight - 1) {
          formData.weight = this.weight - 1
        }
        return this.$http.put(this.$urls.lesson_entity_update, formData, {
          params: { id: this.form.id }
        })
      } else {
        formData['unid'] = this.unid
        formData['coll_id'] = this.cid
        formData['ids'] = this.ids
        return this.$http.post(this.$urls.lesson_entity_batchupdate, formData)
      }
    }
  }
}
</script>
